<template>
  <div>
    <v-card>
      <h1 class="pl-5 pr-5">Organizations</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />
      <FulfillmentStatus ref="fulfillmentStatus"/>
      <!--v-show="!isEdit"-->
      <div class="row pl-5 pr-5" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            id="textSearch"
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col mt-1/2" >
          <v-select
                id="subscriptionType"
                v-model="paging.isASC"
                :items="[{type:'Ascending', value: true}, {type:'Descending', value: false}]"
                label="Order By "
                item-text="type"
                item-value="value"
                return-value="type"
                @change="getOrganizationByPagin()"
              ></v-select>
        </div>
        <div class="col">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4" id="btnNew">
              New Organization
            </v-btn>
          </div>
        </div>
      </div>
      <div v-show="isEdit">
        <v-stepper v-model="purchaseStep">
          <v-stepper-header>
            <v-stepper-step :complete="purchaseStep > 1" step="1" @click="onStepperStep1">
              Organization Details
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="purchaseStep > 2" step="2" @click="onStepperStep2">
              Assignment
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-form ref="form" v-model="valid" lazy-validation>
                <div class="row">
                  <div class="col">
                    <v-text-field
                      id="OrgName"
                      v-model="selectedObj.Name"
                      :rules="organizationRules"
                      label="Organization Name *"
                      required
                    ></v-text-field>
                  </div>
                  <div class="col">
                    <v-text-field
                      id="description"
                      v-model="selectedObj.Description"
                      :rules="organizationDescriptionRules"
                      label="Description"
                      required
                    ></v-text-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-select
                      id="Country"
                      v-model="selectedObj.country"
                      :items="countries"
                      label="Country"
                      item-text="CountryName"
                      item-value="id"
                      return-object
                    ></v-select>
                  </div>
                  <div class="col">
                    <v-text-field
                      id="userLimit"
                      v-model="selectedObj.UserLimit"
                      :rules="userLimitRules"
                      label="User Limit *"
                      required
                      type="number"
                    ></v-text-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-text-field
                      id="organization_address"
                      v-model="selectedObj.Address"
                      label="Address"
                      required
                    ></v-text-field>
                  </div>
                  <div class="col">
                    <v-text-field
                      id="organization_phone"
                      v-model="selectedObj.phone"
                      label="Phone Number"
                      required
                    ></v-text-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-text-field
                      id="website"
                      v-model="selectedObj.website"
                      label="Website"
                      required
                    ></v-text-field>
                  </div>
                  <div class="col">
                    <v-select
                      id="subscriptionType"
                      v-model="selectedObj.subscriptionType"
                      :items="[{type:'Regular'}, {type:'Partner'}, {type:'Test'},{type:'Internal'}]"
                      label="Subscription Type"
                      item-text="type"
                      item-value="type"
                      return-value="type"
                    ></v-select>
                  </div>
                </div>
                <v-divider></v-divider>
                <!-- <h4 class="pt-5">Contact Person</h4>
                <br>
                <div class="row">
                  <div class="col">
                    <v-text-field
                      id="contact_person_name"
                      v-model="selectedObj.contactPersonName"
                      label="Name"
                      required
                    ></v-text-field>
                  </div>
                  <div class="col">
                  <v-text-field
                      id="contact_person_role"
                      v-model="selectedObj.contactPersonRole"
                      label="Role"
                      required
                    ></v-text-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-text-field
                      id="contact_person_email"
                      v-model="selectedObj.contactPersonEmail"
                      label="Email"
                      required
                    ></v-text-field>
                  </div>
                  <div class="col">
                  <v-text-field
                      id="contact_person_phone"
                      v-model="selectedObj.contactPersonPhone"
                      label="Phone"
                      required
                    ></v-text-field>
                  </div>
                </div> -->
                <v-divider></v-divider>
                <h4 class="pt-5">Subscription Administrator</h4>
                <br>
                <div class="row">
                  <div class="col">
                    <v-text-field
                      id="subscription_admin_name"
                      v-model="selectedObj.subscriptionAdminName"
                      :rules="adminRules"
                      label="Name"
                      required
                    ></v-text-field>
                  </div>
                  <div class="col">
                  <v-text-field
                      id="subscription_admin_role"
                      v-model="selectedObj.subscriptionAdminRole"
                      label="Role"
                      required
                    ></v-text-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-text-field
                      id="subscription_admin_email"
                      v-model="selectedObj.subscriptionAdminEmail"
                      :rules="adminEmailRules"
                      label="Email"
                      required
                    ></v-text-field>
                  </div>
                  <div class="col">
                  <v-text-field
                      id="subscription_admin_phone"
                      v-model="selectedObj.subscriptionAdminPhone"
                      label="Phone"
                      required
                    ></v-text-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-text-field
                      id="password_hint"
                      v-model="subscriptionAdminPasswordHint"
                      label="Password Hint"
                      required
                      v-show="!isEditPassword"
                    ></v-text-field>
                  </div>
                  <div class="col">
                  <v-text-field
                      id="subscription_admin_password"
                      v-model="subscriptionAdminPassword"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      label="Password"
                      :type="show1 ? 'text' : 'password'"
                      @click:append="show1 = !show1"
                      :rules="passwordRules"
                      required
                      v-show="!isEditPassword"
                    ></v-text-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="float-right">
                      <v-dialog v-model="dialog" persistent max-width="600px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            id="btnPassword"
                            color="primary"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            class="mr-1 mb-2"
                            @click="onOpenSetPassword()"
                            v-show="isEditPassword"
                          >
                            Set Password
                          </v-btn>
                        </template>
                        <v-card>
                          <v-card-title>
                            <span class="headline">Password</span>
                          </v-card-title>
                          <v-card-text>
                            <v-divider></v-divider>
                            <Notification :notify="notifyPassword" />
                            <v-row>
                              <v-col>
                                <v-text-field
                                  id="passwordHint"
                                  v-model="subscriptionAdminPasswordHint"
                                  label="Password Hint*"
                                  required
                                  counter
                                >
                                </v-text-field
                              ></v-col>
                              <v-col>
                                <v-text-field
                                  id="password"
                                  v-model="subscriptionAdminPassword"
                                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                  :type="show1 ? 'text' : 'password'"
                                  name="input-10-1"
                                  label="Password*"
                                  hint="At least 6 characters"
                                  counter
                                  :rules="passwordRules"
                                  @click:append="show1 = !show1"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn
                              id="btnClose"
                              color="blue darken-1 mr-2"
                              text
                              @click="dialog = false"
                            >
                              Close
                            </v-btn>
                            <v-btn color="blue darken-1" text @click="onSavePassword()" id="btnSave">
                              Save
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </div>
                  </div>
                </div>
                <!-- <v-divider></v-divider>
                <h4 class="pt-5">Collections</h4>
                <br>
                <div class="row">
                  <div class="col">
                    <v-text-field
                      id="collection"
                      label="Collection"
                      v-model="collections"
                      disabled
                      required
                    ></v-text-field>
                  </div>
                  <div class="col">
                  
                  </div> -->
                <!-- </div> -->
                <v-divider></v-divider>
                <h4 class="pt-5">Configurations</h4>
                <br>
                <div class="row">
                  <div class="col">
                    <v-text-field
                      id="lendingDuration"
                      v-model="selectedObj.LendingDuration"
                      :rules="LendingDurationRules"
                      label="Lending Duration"
                      required
                      type="number"
                    ></v-text-field>
                  </div>
                  <div class="col">
                  
                  </div>
                </div>
                <v-divider  class="pt-5"></v-divider>
                <div class="row mb-4">
                  <div class="col">
                    <div class="float-right action-area">
                      <v-btn @click="onCancel()" id="btnCancel" class="mr-2"> Cancel </v-btn>
                      <v-btn
                        id="btnSave"
                        class="mr-2"
                        color="primary"
                        @click="onSave()"
                        :loading="loading"
                        :disabled="loading"
                      >
                        Save
                      </v-btn>
                      <v-btn class="" @click="onStepperStep2" id="nxtbtn" :disabled="this.id == 0"
                          >Assign Collections</v-btn
                        >
                    </div>
                  </div>
                </div>
              </v-form>
            </v-stepper-content>
              <v-stepper-content step="2">
                <v-card class="mb-4">
                  <v-toolbar dark color="primary" dense>
                    <v-toolbar-title class="text-body-1">
                      Current Assignments for {{ selectedObj.Name }}
                    </v-toolbar-title>
                  </v-toolbar>

                  <v-card-text>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th style="width: 300px" class="text-left">Name</th>
                            <th style="width: 500px" class="text-left">Description</th>
                            <th style="width: 200px" class="text-left">Start Date</th>
                            <th style="width: 200px" class="text-left">End Date</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in subscriptionHistory" :key="item.id" v-if="new Date(item.endDate) > new Date()">
                            <td>{{ item.Name }}</td>
                            <td>{{ item.Description }}</td>
                            <td>{{ item.startDate | dateUtcToLocal }}</td>
                            <td>{{ item.endDate | dateUtcToLocal }}</td>
                            <td>
                              <v-btn small color="error" @click="removeAssignment(item)">Remove</v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>

                    <div v-if="historyLoading" class="pt-3">Loading history...</div>
                  </v-card-text>
                </v-card>
              <h1>Collections Assignment</h1>
              <v-divider></v-divider>

  <!-- Common Date Pickers Outside Table -->
                <div class="row">
                  <v-col cols="12" md="6">
                    <v-menu
                      v-model="satrtDateAction"
                      :close-on-content-click="true"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          id="startDate"
                          v-model="satrtDate"
                          prepend-icon="mdi-calendar"
                          label="Start date"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="[(v) => !!v || 'Start date is required']"
                        ></v-text-field>
                      </template>

                      <v-date-picker
                        id="startDatePic"
                        v-model="satrtDate"
                        @input="satrtDateAction = false"
                        :max="endDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-menu
                      v-model="endDateAction"
                      :close-on-content-click="true"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          id="enddate"
                          v-model="endDate"
                          prepend-icon="mdi-calendar"
                          label="End date"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="[(v) => !!v || 'End date is required']"
                        ></v-text-field>
                      </template>

                      <v-date-picker
                        id="endDatePic"
                        v-model="endDate"
                        @input="endDateAction = false"
                        :min="satrtDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </div>

                <!-- Table -->
                <div class="row">
                  <v-col cols="12">
                    <v-data-table
                      v-model="selected_fulfillment"
                      :headers="fulfillment_headers"
                      :items="availableCollections"
                      class="elevation-1"
                      show-select
                      id="fulfillment"
                    >
                      <template v-slot:item.name="props">
                        <p class="text-wrap">{{ props.item.name }}</p>
                      </template>
                    </v-data-table>
                  </v-col>
                </div>

  <!-- Buttons -->
                <div class="row">
                    <div class="col d-flex justify-end">
                      <div class="ms- 6 col d-flex justify-start">
                        <v-btn class="" @click="purchaseStep = 1" id="btnback"
                          >Back</v-btn
                        >
                      </div>
                      <div class="col d-flex justify-end">
                        <v-btn class="mr-2" @click="getSubcriptionHistory()">
                          Subscription History
                        </v-btn>
                        <v-btn
                          color="primary"
                          class=""
                          id="submit-assignment"
                          @click="createFulfillment()"
                          :loading="loading"
                          :disabled="loading"
                          >Assign And Submit</v-btn
                        >
                      </div>
                    </div>
                  </div>
              </v-stepper-content>
          </v-stepper-items>
        <ConfirmationDialog ref="confirm" />
        </v-stepper>
      </div>
      <!--
      <div v-show="isEdit && this.selectedObj.id > 0">   
        <v-tabs v-model="tab">
          <v-tab v-for="item in items" :key="item">
            {{ item }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">          
          <v-tab-item ><PurchasedCollections :organization="selectedObj"/></v-tab-item>
        </v-tabs-items>
      </div>
      -->
      <div class="row mt-5" v-show="!isEdit">
        <div class="col">
          <v-simple-table>
            <template v-slot:default>
              <!-- simple sort by clicking headers -->
              <thead>
                <tr>
                  <th class="text-left" @click="sortByName" style="cursor: pointer">
                    Organization Name
                  </th>
                  <th class="text-left" @click="sortByDescription" style="cursor: pointer">
                    Description
                  </th>
                  <th class="text-left" @click="sortByCountry" style="cursor: pointer">
                    Country
                  </th>
                  <th class="text-left" @click="sortBySubscriptionType" style="cursor: pointer">
                    Subscription Type
                  </th>
                  <th class="text-left" @click="sortByUserLimit" style="cursor: pointer">
                    User Limit
                  </th>
                  <th class="text-left" @click="sortByStartDate" style="cursor: pointer">
                    Start Date
                  </th>
                  <th class="text-left" @click="sortByEndDate" style="cursor: pointer">
                    End Date
                  </th>
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in list" :key="item.id" :id="'svg' + i">
                  <td>{{ item.Name }}</td>
                  <td>{{ item.Description }}</td>
                  <td>
                    {{ item.country != null ? item.country.CountryName : "" }}
                  </td>
                  <td >
                    {{ item.subscriptionType }}
                  </td>
                  <!---->
                  <td>{{ item.UserLimit }}</td>
                  <td> 
                    {{ item.earliestSubscriptionStartDate | dateUtcToLocal }}
                  </td>
                  <td>
                    {{ item.earliestSubscriptionEndDate | dateUtcToLocal }}
                  </td>
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>
<script>
import Notification from "@/components/Notification";
import Pagination from "@/components/Pagination";
import PurchasedCollections from "@/components/PurchasedCollections";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import moment from "moment";
import * as api from "@/api";
import FulfillmentStatus from "../components/FulfillmentStatus.vue";
import { sort } from "semver";
export default {
  name: "Organization",
  components: {
    Notification,
    Pagination,
    PurchasedCollections,
    ConfirmationDialog,
    FulfillmentStatus
  },
  computed: {
    availableCollections() {
      const now = new Date();

      const activeIds = new Set(
        this.subscriptionHistory
          .filter(row => new Date(row.endDate) > now)
          .map(row => row.collectionId || row.CollectionId || row.id)
          .filter(Boolean)
      );

      return this.collectionList.filter(item => !activeIds.has(item.id));
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  created() {
    this.getCountries();
    this.getOrganizationByPagin();
  },
  mounted() {
    this.getCollections();
  },
  methods: {
    async removeAssignment(item) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to cancel this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .update("lending/cancel/" + item.id, {"id":0})
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                new Promise((resolve, reject) => {
                  api
                    .DeleteByID("purchase-order/cancel", item.purchaseOrderId)
                    .then((response) => {
                      resolve(response);
                      this.loadSubscriptionHistory();
                    })
                    .catch((error) => {
                      reject(error);
                    });
                });
              }
            })
            .catch((error) => {});
        });
      }
    },
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getOrganizationByPagin();
    },
    onNextPage(page) {
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getOrganizationByPagin();
    },
  getOrganizationByPagin() {
      let that = this;
          that.overlay = true
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("organization", this.paging)
              .then((response) => {
                that.overlay = false
            this.list = response.data.data;
            this.paging.count = response.data.count;
            that.loadEarliestSubscriptionDates(this.list);
                  })
          .catch((error) => {
            that.overlay = false
            reject(error);
          });
      });
    },
    getEarliestSubscriptionSummary(purchaseOrders) {
      if (!purchaseOrders || purchaseOrders.length === 0) {
        return null;
      }

      let earliest = null;

      purchaseOrders.forEach((order) => {
        const details =
          order && Array.isArray(order.PurchaseDetails)
            ? order.PurchaseDetails
            : [];

        details.forEach((detail) => {
          const endDate = detail.EndDate || detail.endDate;
          if (!endDate) {
            return;
          }

          const endMoment = moment(endDate);
          if (!endMoment.isValid()) {
            return;
          }

          if (!earliest || endMoment.isAfter(earliest.endMoment)) {
            earliest = {
              startDate: detail.StartDate || detail.startDate || null,
              endDate: endDate,
              endMoment: endMoment,
            };
          }
        });
      });

      if (!earliest) {
        return null;
      }

      return {
        startDate: earliest.startDate,
        endDate: earliest.endDate,
      };
    },
    loadEarliestSubscriptionDates(list) {
      if (!list || list.length === 0) {
        return;
      }

      const requestPaging = {
        count: 10,
        page: 1,
        size: 1000,
        keyword: "",
        isIndividual: false,
      };

      const requests = [];

      list.forEach((item) => {
        if (!item || !item.id) {
          return;
        }

        this.$set(item, "earliestSubscriptionStartDate", "");
        this.$set(item, "earliestSubscriptionEndDate", "");

        const request = api
          .getByPagin(
            "purchase-order/organization-collection/" + item.id,
            requestPaging
          )
          .then((response) => {
            const purchaseOrders = response.data && response.data.data
              ? response.data.data.filter(po => po.IsCancel === false)
              : [];
            const summary = this.getEarliestSubscriptionSummary(purchaseOrders);
            const startDate = summary ? summary.startDate : "";
            const endDate = summary ? summary.endDate : "";

            this.$set(item, "earliestSubscriptionStartDate", startDate);
            this.$set(item, "earliestSubscriptionEndDate", endDate);
          })
          .catch(() => {
            this.$set(item, "earliestSubscriptionStartDate", "");
            this.$set(item, "earliestSubscriptionEndDate", "");
          });

        requests.push(request);
      });

      if (requests.length > 0) {
        Promise.all(requests);
      }
    },
    onNew() {
      this.isEdit = true;
      this.id = 0;
      this.selectedObj.Name = "";
      this.selectedObj.Description = "";
      this.selectedObj.UserLimit = 0;
      this.selectedObj.LicenseLimit = 0;
      this.selectedObj.LendingDuration = 14;
      this.selectedObj.Address = "";
      this.selectedObj.website = "";
      this.selectedObj.phone = "";
      this.selectedObj.subscriptionType = "";
      this.selectedObj.contactPersonName = "";
      this.selectedObj.contactPersonRole = "";
      this.selectedObj.contactPersonEmail = "";
      this.selectedObj.contactPersonPhone = "";
      this.selectedObj.subscriptionAdminName = "";
      this.selectedObj.subscriptionAdminRole = "";
      this.selectedObj.subscriptionAdminEmail = "";
      this.selectedObj.subscriptionAdminPhone = "";
      this.valid = false;
      this.selectedObj.id = 0;
      this.userDetails = {};
      this.isEditPassword = false;
    },
    onSave() {
      let that = this;
      that.overlay = true
      this.$refs.form.validate();
      console.log(this.valid);
      if (!this.valid){
         that.overlay = false;
         return;
      }
      that.id = this.selectedObj.id;
      new Promise((resolve, reject) => {
        api
          .update("organization", this.selectedObj)
          .then((response) => {
            resolve(response);
            console.log(response.status);
            console.log("respoinse" ,response);
            if (response.status === 200 || response.status === 201) {
              this.notify.type = 1;
              this.id = this.id !== 0 ? this.id : response.data.id;
              this.selectedObj.id = this.id;
              this.getOrganizationByPagin();
              return response.data;
            } else {
              that.overlay = false
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              });
              return Promise.reject("Failed to save data.");
            }
          })
          .then((data) => {
            var userObj = {};
            if (data.id > 0) {
              userObj = {
                id: 0,
                firstName: this.selectedObj.subscriptionAdminName,
                lastName: "",
                email: this.selectedObj.subscriptionAdminEmail,
                phone: this.selectedObj.subscriptionAdminPhone,
                role: this.selectedObj.subscriptionAdminRole,
                organization: this.selectedObj,
                isOrganizationUser: true,
                password: this.subscriptionAdminPassword,
                passwordhint: this.subscriptionAdminPasswordHint,
                userRole:{
                  id: 3,
                  isOrganization: true,
                  roleKey: "PortalAdmin",
                  roleName: "Portal Admin"
                }
              };
            } else {
              if(this.userDetails && this.userDetails.id != undefined){
                  userObj = {
                  id: this.userDetails.id,
                  firstName: this.selectedObj.subscriptionAdminName,
                  lastName: "",
                  email: this.selectedObj.subscriptionAdminEmail,
                  phone: this.selectedObj.subscriptionAdminPhone,
                  role: this.selectedObj.subscriptionAdminRole,
                  organization: this.selectedObj,
                  isOrganizationUser: true,
                  userRole:{
                    id: 3,
                    isOrganization: true,
                    roleKey: "PortalAdmin",
                    roleName: "Portal Admin"
                  }
                };
              } else {
                userObj = {
                  id: 0,
                  firstName: this.selectedObj.subscriptionAdminName,
                  lastName: "",
                  email: this.selectedObj.subscriptionAdminEmail,
                  phone: this.selectedObj.subscriptionAdminPhone,
                  role: this.selectedObj.subscriptionAdminRole,
                  organization: this.selectedObj,
                  isOrganizationUser: true,
                  password: this.subscriptionAdminPassword,
                  passwordhint: this.subscriptionAdminPasswordHint,
                  userRole:{
                    id: 3,
                    isOrganization: true,
                    roleKey: "PortalAdmin",
                    roleName: "Portal Admin"
                  }
                };
              }
            }

            api
            .update("user", userObj)
            .then((response) => {
              resolve(response);
              console.log(response.status);
              console.log("respoinse" ,response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.isEditPassword = true;
                this.selectedObj.id = this.id;
                this.purchaseStep = 2;
                if (that.id == 0) {
                  this.notify.message = "Record successfully created.";
                } else {
                  this.notify.message = "Record successfully updated.";
                }
                this.getPortalUserDetails();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                that.overlay = false
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth',
                });
              }
              that.overlay = false
            }).catch((error) => {
              that.overlay = false
              this.notify.type = 4;
              this.notify.errors.push("Failed to save Subscription Admin User (Portal Admin). Subscription Admin Email might be already in use. Please change the email and try again.");
              console.log(error);
              this.isEditPassword = this.userDetails.id != undefined ? true : false;
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              });
              reject(error);
            });
          })
          .catch((error) => {
            if (error.response.status == 409) {
              this.notify.type = 4;
              this.notify.errors.push("Organization name already exist");
              this.loading = false;
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              });
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              console.log(error);
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              });
              reject(error);
            }
            that.overlay = false
          });
      });
      // this.isEdit = false;
      // this.$refs.form.reset();
    },
  onStepperStep1() {
    this.purchaseStep = 1;
  },

  async onStepperStep2() {
    this.purchaseStep = 2;
    await this.loadSubscriptionHistory();
  },
    onEdit(obj) {
      this.isEdit = true;
      this.selectedObj = Object.assign({}, obj);
      this.id = obj.id;
      // this.satrtDate = obj.earliestSubscriptionStartDate.split("T")[0]
      this.satrtDate = new Date().toISOString().split("T")[0];
      this.endDate = obj.earliestSubscriptionEndDate.split("T")[0] > new Date().toISOString().split("T")[0] ? obj.earliestSubscriptionEndDate.split("T")[0] : this.satrtDate;
      console.log(this.id);
      this.isEditPassword = true;
      this.getPortalUserDetails();
      this.loadSubscriptionHistory();
    },
    async getPortalUserDetails() {
      new Promise((resolve, reject) => {
          api
            .getByID("user/organization", this.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                console.log(response.data);
                this.userDetails = response.data.filter(x => x.userRole.id === 3)[0];
                this.subscriptionAdminPasswordHint = this.userDetails.passwordhint;
              }
            })
      });
    },
    async onDelete(obj) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("organization", obj.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                setTimeout(() => {
                  this.notify.type = 0;
                  this.getOrganizationByPagin();
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch((error) => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }

      this.isEdit = false;
    },
    onCancel() {
      this.isEdit = false;
      this.id = 0;
      this.$refs.form.reset();
    },
    getOrganization() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getAll("organization")
          .then((response) => {
            this.list = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCountries() {
      this.countries = [];
      new Promise((resolve, reject) => {
        api
          .getAll("country")
          .then((response) => {
            console.log(response.data);
            this.countries = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCollections() {
      let that = this;
      new Promise((resolve, reject) => {
        api
          .getAll("collection")
          .then((response) => {
            console.log(response);
            response.data.forEach((e) => {
              e.satrtDate = "";
              e.endDate = "";
              that.collectionList.push(e);
            });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async createFulfillment() {
        this.notify = {
          type: 0,
          message: "",
          errors: [],
        };

        let that = this;
        that.overlay = true;

        /* validate selected collections */
        if (
          !that.selected_fulfillment ||
          that.selected_fulfillment.length === 0
        ) {
          that.overlay = false;
          this.notify.type = 4;
          this.notify.errors.push(
            "Please select at least one collection to assign."
          );
          return;
        }

        /* validate common dates outside table */
        if (!this.satrtDate || !this.endDate) {
          that.overlay = false;
          this.notify.type = 4;
          this.notify.errors.push(
            "Start date and End date are required."
          );
          return;
        }

        // Process each selected collection individually
        const promises = that.selected_fulfillment.map((collection) => {
          let purchaseReqeust = {
            id: 0,
            Amount: 0,
            DateOfPayment: moment().toDate(),
            ReferenceNo: process.env.DEFAULT_REFERENCE_NO,
            PaymentMadeBy: process.env.DEFAULT_PAYER,
            PaymentConfirmed: true,
            IsCollection: true,
            OrganizationId: this.id,
            PurchaseDetails: [
              {
                NoOfCopies: Number(this.selectedObj.UserLimit),
                StartDate: moment(this.satrtDate).toDate(),
                EndDate: moment(this.endDate).toDate(),
                PublicationId: collection.PublicationId,
                collectionId: collection.id,
                journalId: collection.journalId,
                id: 0,
                collectionType: collection.collectionType,
              }
            ],
          };

          return new Promise((resolve, reject) => {
            api
              .update("purchase-order", purchaseReqeust)
              .then((response) => {
                resolve({
                  response: response,
                  collection: collection,
                  success: response.status === 200 || response.status === 201
                });
              })
              .catch((error) => {
                resolve({
                  response: null,
                  collection: collection,
                  success: false,
                  error: error
                });
              });
          });
        });

        // Wait for all promises to complete
        const results = await Promise.all(promises);

        // Process results
        let successCount = 0;
        let errorCount = 0;
        const errors = [];

        results.forEach(result => {
          if (result.success) {
            successCount++;
          } else {
            errorCount++;
            if (result.error) {
              errors.push(`Failed to save data for collection ${result.collection.name}: ${result.error.message || result.error}`);
            } else {
              errors.push(`Failed to save data for collection ${result.collection.name}`);
            }
          }
        });

        // Set notification based on results
        if (errorCount === 0) {
          this.notify.type = 1;
          this.notify.message = `Successfully saved ${successCount} purchase order${successCount !== 1 ? 's' : ''}.`;
        } else if (successCount === 0) {
          this.notify.type = 4;
          this.notify.errors = errors;
        } else {
          this.notify.type = 4; // Using type 4 for partial success as well
          this.notify.message = `Successfully saved ${successCount} purchase order${successCount !== 1 ? 's' : ''}.`;
          this.notify.errors = errors;
          this.purchaseStep = 1;
        }

        // Reset form and state
        this.isEdit = false;
        this.$refs.form.reset();
        this.selected_fulfillment = [];
        this.collectionList = [];
        this.satrtDate = null;
        this.endDate = null;
        this.getCollections();
        that.overlay = false;

        // Hide notification after delay if there were errors or show success
        setTimeout(() => {
          this.notify.type = 0;
        }, 3000);
        },
    getSubcriptionHistory() {
      let that = this;
      // that.overlay = true;
      // // const subscriptionHistory = [];
      // new Promise((resolve, reject) => {
      //   api
      //     .getByPagin("purchase-order/organization-collection/" + this.id, { count: 10, page: 1, size: 1000, keyword: "", isIndividual: false })
      //     .then((response) => {
      //       resolve(response);
      //       console.log("order",response.data);
            that.$refs.fulfillmentStatus.open(this.tempHistory || []);
      //       that.overlay = false;
      //     })
      //     .catch((error) => {
      //       reject(error);
      //       that.overlay = false;
      //     });
      // });
    },
    onSavePassword() {
      this.notifyPassword.errors = [];
      //this.notifyPassword.errors.splice(0, this.notify.errors.length);
      this.notifyPassword.type = 4;

      if (this.subscriptionAdminPasswordHint === "") {
        this.notifyPassword.errors.push("Password hint required.");
        return true;
      }
      if (this.subscriptionAdminPassword === "") {
        this.notifyPassword.errors.push("Password required.");
        return true;
      }
      if (this.subscriptionAdminPassword != null && this.subscriptionAdminPassword.length < 6) {
        this.notifyPassword.errors.push("Password required.");
        return true;
      }

      var obj = {
        id: this.userDetails.id,
        password: this.subscriptionAdminPassword,
        passwordhint: this.subscriptionAdminPasswordHint,
      };
      new Promise((resolve, reject) => {
        api
          .update("user/set-password", obj)
          .then((response) => {
            resolve(response);
            if (response.status === 200 || response.status === 201) {
              this.dialog = false;
              this.notify.type = 1;
              this.notify.message =
                this.userDetails.id === -1
                  ? "Password successfully saved."
                  : "Password successfully updated.";
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
            }
          })
          .catch((error) => {
            this.notify.type = 4;
            this.notify.errors.push("Failed to save data. " + error);
            reject(error);
          });
      });

      this.dialog = false;
    },
    onOpenSetPassword() {
      this.notifyPassword.errors = [];
    },
    sortByName() {
      this.nameSortAsc = !this.nameSortAsc;
      this.list = this.list.sort((a, b) => this.nameSortAsc ? a.Name.localeCompare(b.Name) : b.Name.localeCompare(a.Name));
    },
    sortByDescription() {
      this.descriptionSortAsc = !this.descriptionSortAsc;
      this.list = this.list.sort((a, b) => this.descriptionSortAsc ? a.Description.localeCompare(b.Description) : b.Description.localeCompare(a.Description));
    },
    sortByCountry() {
      this.countrySortAsc = !this.countrySortAsc;
      this.list = this.list.sort((a, b) => this.countrySortAsc ? (a.country != null ? a.country.CountryName : '').localeCompare(b.country != null ? b.country.CountryName : '') : (b.country != null ? b.country.CountryName : '').localeCompare(a.country != null ? a.country.CountryName : ''));
    },
    sortBySubscriptionType() {
      this.subscriptionTypeSortAsc = !this.subscriptionTypeSortAsc;
      this.list = this.list.sort((a, b) => this.subscriptionTypeSortAsc ? a.subscriptionType.localeCompare(b.subscriptionType) : b.subscriptionType.localeCompare(a.subscriptionType));
    },
    sortByUserLimit() {
      this.userLimitSortAsc = !this.userLimitSortAsc;
      this.list = this.list.sort((a, b) => this.userLimitSortAsc ? a.UserLimit - b.UserLimit : b.UserLimit - a.UserLimit);
    },
    sortByStartDate() {
      this.startDateSortAsc = !this.startDateSortAsc;
      this.list = this.list.sort((a, b) => {
        const dateA = a.earliestSubscriptionStartDate ? new Date(a.earliestSubscriptionStartDate) : new Date(0);
        const dateB = b.earliestSubscriptionStartDate ? new Date(b.earliestSubscriptionStartDate) : new Date(0);
        return this.startDateSortAsc ? dateA - dateB : dateB - dateA;
      });
    },
    sortByEndDate() {
      this.endDateSortAsc = !this.endDateSortAsc;
      this.list = this.list.sort((a, b) => {
        const dateA = a.earliestSubscriptionEndDate ? new Date(a.earliestSubscriptionEndDate) : new Date(0);
        const dateB = b.earliestSubscriptionEndDate ? new Date(b.earliestSubscriptionEndDate) : new Date(0);
        return this.endDateSortAsc ? dateA - dateB : dateB - dateA;
      });
    },
    async loadSubscriptionHistory() {
      if (!this.id) return;

      this.historyLoading = true;
      this.subscriptionHistory = [];

      try {
        const response = await api.getByPagin("purchase-order/organization-collection/" + this.id, { count: 10, page: 1, size: 1000, keyword: "", isIndividual: false });
        console.log("purchase",response.data)
        const purchaseOrders = response.data.data || [];

        const detailRequests = purchaseOrders.map((order) => {
          const url = order.IsCollection
            ? "purchase-order/collection/" + order.id
            : "purchase-order/publication/" + order.id;

          return api.getByPagin(url, {
            count: 10,
            page: 1,
            size: 1000,
            keyword: "",
          });
        });

        const detailResponses = await Promise.all(detailRequests);
        const allRows = [];
        const allHistory = [];
        console.log("details",detailResponses)
        purchaseOrders.forEach((order, index) => {
          const detail = detailResponses[index].data.data.forEach((data) => {
            if (data) {
              // Attach purchase order fields needed for cancellation
              data.purchaseOrderId = order.id;
              data.organizationId = order.OrganizationId;
              data.isCollection = order.IsCollection;
              if (data.IsCancel === false) {
                allRows.push(data);
              }
              allHistory.push(data);
            }
          });  
        });

        this.tempHistory = allHistory;

        this.subscriptionHistory = allRows.filter((row) =>
        this.isActiveSubscriptionRow(row)
      );
      } finally {
        this.historyLoading = false;
      }
  },
  isActiveSubscriptionRow(row) {
    const now = moment();
    const startDate = moment(row.StartDate);
    const endDate = moment(row.EndDate);

    return now.isBetween(startDate, endDate, null, "[]");
  }
  },
  data() {
    return {
      id: 0,
      list: [],
      collectionList: [],
      subscriptionHistory: [],
      historyLoading: false,
      fulfillment_headers: [
        {
          text: "Collection",
          align: "start",
          sortable: false,
          value: "Name",
          width: "30%",
        },
        {
          text: " ",
          align: "start",
          sortable: false,
          value: "satrtDate",
          width: "35%",
        },
        {
          text: "",
          align: "start",
          sortable: false,
          value: "endDate",
          width: "35%",
        },
      ],
      selected_fulfillment: [],
      purchaseStep: 1,
      isEdit: false,
      isNew: false,
      Search: "",
      selectedObj: {
        id: 0,
        isIndividual: false,
        Name: "",
        Description: "",
        UserLimit: 0,
        LicenseLimit: 0,
        LendingDuration: 14,
        Address: "",
        phone: "",
        website: "",
        subscriptionType: "",
        contactPersonName: "",
        contactPersonRole: "",
        contactPersonEmail: "",
        contactPersonPhone: "",
        subscriptionAdminName: "",
        subscriptionAdminRole: "",
        subscriptionAdminEmail: "",
        subscriptionAdminPhone: ""
      },
      //form: Object.assign({}, defaultForm),
      id: 0,
      Name: "",
      Description: "",
      UserLimit: 0,
      LicenseLimit: 0,
      LendingDuration: 14,
      organizationRules: [(v) => !!v || "Organization Name is required"],
      organizationDescriptionRules: [(v) => !!v || "Organization Description is required"],
      userLimitRules: [(v) => !!v || "User Limit is required", v => (v && parseInt(v) > 0) || 'User Limit should be greator than zero'],
      licenseLimitRules: [(v) => !!v || "License Limit is required"],
      LendingDurationRules: [(v) => !!v || "Lending duration is required" , v => (v && parseInt(v) > 0) || 'Lending duration should be greator than zero'],
      adminRules: [(v) => !!v || "Subscription Admin Name is required"],
      adminEmailRules: [(v) => !!v || "Subscription Admin Email is required"],
      Address: "",
      phone: "",
      website: "",
      subscriptionType: "",
      contactPersonName: "",
      contactPersonRole: "",
      contactPersonEmail: "",
      contactPersonPhone: "",
      subscriptionAdminName: "",
      subscriptionAdminRole: "",
      subscriptionAdminEmail: "",
      subscriptionAdminPhone: "",
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      valid: false,
      loading: false,
      paging: { count: 10, page: 1, size: 10, keyword: "", isIndividual: false, isASC: true },
      tab: null,
      items: ["Assign BiblioTech collections"], // "Licenses", "Collections",
      overlay : false,
      collections: "Core Collection",
      subscriptionAdminPasswordHint: "",
      subscriptionAdminPassword: "",
      reg: '/^(([^<>()[]\\.,;:s@"]+(.[^<>()[]\\.,;:s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,24}))$/',
      show1: false,
      dialog: false,
      isEditPassword: false,
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 6) || "The password should have a minimum of 6 characters",
      ],
      userDetails: {},
      notifyPassword: {
          type: 0,
          message: "",
          errors: [],
        },
      nameSortAsc: false,
      descriptionSortAsc: false,
      countrySortAsc: false,
      subscriptionTypeSortAsc: false,
      startDateSortAsc: false,
      endDateSortAsc: false,
    };
  },
};
</script>
<style scoped>
.icon-edit {
  color: #1975d2;
}
.icon-delete {
  color: red;
}
.col {

}
</style>



// WEBPACK FOOTER //
// src/views/Organization.vue